import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { DefaultButton, Dropdown, Panel, PrimaryButton, SpinButton, Stack, TextField } from "@fluentui/react";
import AuthContext from "../../Services/AuthContext";
import { dbDate } from "../../Utilities/dbDate";
import DatePickerPL from "../../Components/DatePickerPL";
import NetGrossPicker from "../../Components/NetGrossPicker";


function EditVentureAgreement(props) {
    const [user] = useContext(AuthContext);
    const [name, setName] = useState("");
    const [agreementNumber, setAgreementNumber] = useState("");
    const [representative, setRepresentative] = useState("");
    const [date, setDate] = useState(new Date());
    const [paymentDeadline, setPaymentDeadline] = useState(14);
    const [net, setNet] = useState(0);
    const [vat, setVat] = useState(0);
    const [gross, setGross] = useState(0);
    const [agreementCategory, setAgreementCategory] = useState(null);
    const [agreementCategories, setAgreementCategories] = useState([]);
    const [contractor, setContractor] = useState(null);
    const [contractors, setContractors] = useState([]);

    const _submit = (e) => {
        e.preventDefault();
        props.add.id
        const data = {
            name: name,
            agreement_number: agreementNumber,
            representative: representative,
            date: dbDate(date),
            payment_deadline: paymentDeadline,
            net_value: net,
            vat: vat,
            gross_value: gross,
            venture_id: props.add.venture_id,
            agreement_category_id: agreementCategory.key,
            contractor_id: contractor.key,
        };
        fetch(`/api/venture/agreement/${props.add.id}`, {
            method: "PUT",
            body: JSON.stringify(data),
            headers: {
                "Authorization": "Bearer " + user.token,
            },
        }).then(res => res.json())
            .then(json => {
                props.onSuccess(json);
                props.dismissPanel();
            })
            .catch(err => {
                console.log(err);
            });
    };

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign="space-between">
        <PrimaryButton type="submit" form="EditVentureAgreement">Zapisz</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        const abortController = new AbortController();
        setName(props.add.name);
        setAgreementNumber(props.add.agreement_number);
        setRepresentative(props.add.representative);
        setDate(new Date(dbDate(props.add.date)));
        setPaymentDeadline(props.add.payment_deadline);
        setNet(props.add.net_value);
        setVat(props.add.vat);
        setGross(props.add.gross_value);
        setAgreementCategory({key: props.add.agreement_category_id})
        setContractor({ key: props.add.contractor_id})

        if (props.add) {
            async function fetchCategories() {
                await fetch(`/api/agreement_category`, {
                    method: "GET",
                    signal: abortController.signal,
                    headers: {
                        "Authorization": "Bearer " + user.token,
                    },
                }).then(res => res.json())
                    .then(data => {
                        setAgreementCategories(data.map((item) => {
                            return { key: item.id, text: `${item.type} - ${item.name}` };
                        }));
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
            async function fetchContractors() {
                await fetch(`/api/contractor`, {
                    method: 'GET',
                    signal: abortController.signal,
                    headers: {
                        'Authorization': 'Bearer ' + user.token
                    }
                }).then(res => res.json())
                    .then(data => {
                        setContractors(data.map((item) => {
                            return {key: item.id, text: item.name};
                        }))
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
            fetchContractors();
            fetchCategories();
        }
        return () => abortController.abort();
    }, [props.add])



    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Edytuj koszt"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id="EditVentureAgreement">
                <TextField required autoFocus label="Nazwa" value={name}
                           onChange={(e) => setName(e.target.value || "")} />
                <Dropdown
                    label="Kategoria"
                    selectedKey={agreementCategory ? agreementCategory.key : undefined}
                    onChange={(e, item) => setAgreementCategory(item)}
                    placeholder="Wybierz z listy"
                    options={agreementCategories}
                    required

                />
                <Dropdown
                    label="Wykonawca"
                    selectedKey={contractor ? contractor.key : undefined}
                    onChange={(e, item) => setContractor(item)}
                    placeholder="Wybierz z listy"
                    options={contractors}
                    required
                />
                <TextField required label="Reprezentowany przez" value={representative}
                           onChange={(e) => setRepresentative(e.target.value || "")} />
                <TextField required label="Numer Umowy" value={agreementNumber}
                           onChange={(e) => setAgreementNumber(e.target.value || "")} />
                <DatePickerPL
                    label="Data"
                    isRequired={true}
                    placeholder="Wybierz datę..."
                    ariaLabel="Wybierz datę"
                    value={date}
                    onSelectDate={(e) => setDate(e || '')}
                />
                <NetGrossPicker net={net} setNet={setNet} gross={gross} setGross={setGross} vat={vat} setVat={setVat} />
                <SpinButton
                    label={"Termin Płatności"}
                    labelPosition={"top"}
                    step={1}
                    min={0}
                    max={100}
                    incrementButtonAriaLabel={"+1"}
                    decrementButtonAriaLabel={"-1"}
                    value={paymentDeadline}
                    onChange={(e) => setPaymentDeadline(e.target.value || "")}
                />

            </form>
        </Panel>
    );
}

export default EditVentureAgreement;